class BusinessConstant {

    static get QUOTE_EXPIRES_IN_DAYS() {
        return 14;
    }

    static get CC_COVERAGE_MAINTENANCE() {
        return 'z5khi2u3qnqpcberbfaljcep4ea'; // PSA PUWMaintenanceCov
    }

    static get LOSSCAUSE_DEFECT() {
        return 'Defect_PSA';
    }

    static get LOSSCAUSE_MAINTENANCE() {
        return 'CarMaintenance_PSA';
    }
}

export default BusinessConstant;